<template>
    <Intro :labelAndDescColor="customColor"/>
    <VacChild />
    <VacAdult />
    <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/naviVaccination/NaviVaccinationIntro.vue";
import VacChild from "@/components/naviVaccination/NaviVaccinationChild.vue";
import VacAdult from "@/components/naviVaccination/NaviVaccinationAdult.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";
import { useRoute } from "vue-router";

import { computed, onMounted, ref, toRefs } from "vue";

const route = useRoute();

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});

const customColor = computed(() => {
  return route.meta.color || '#82488F';
});

</script>